module.exports = __webpack_public_path__ + "static/img/00 main.6f9108e1.jpg";